import SupabaseOriginal from "devicons-react/icons/SupabaseOriginal";

export const SkillsData = [
  {
    type: "Web-Development",
    list: [
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS3",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: "TypeScript",
        icon: <i class="devicon-typescript-plain colored"></i>,
      },
      {
        name: "Tailwind CSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>,
      },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "NextJS",
        icon: <i class="devicon-nextjs-plain colored"></i>,
      },
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>,
      },
      {
        name: "Supabase",
        icon: (
          <SupabaseOriginal className="devicon-supabase-original colored" />
        ),
      },
    ],
  },
  {
    type: "App-Development",
    list: [
      {
        name: "Nativewind CSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>,
      },
      {
        name: "React Native",
        icon: <i class="devicon-react-original colored"></i>,
      },
    ],
  },
  {
    type: "DevOps",
    list: [
      {
        name: "Linux",
        icon: <i class="devicon-linux-plain colored"></i>,
      },
      {
        name: "AWS",
        icon: <i className="devicon-amazonwebservices-original colored"></i>,
      },
      {
        name: "Jenkins",
        icon: <i class="devicon-jenkins-plain colored"></i>,
      },
      {
        name: "Ansible",
        icon: <i class="devicon-ansible-plain colored"></i>,
      },
      {
        name: "Docker",
        icon: <i class="devicon-docker-plain colored"></i>,
      },
      {
        name: "Kubernetes",
        icon: <i class="devicon-kubernetes-plain colored"></i>,
      },
      {
        name: "Prometheus",
        icon: <i className="devicon-prometheus-original colored"></i>,
      },
      {
        name: "Grafana",
        icon: <i class="devicon-grafana-plain colored"></i>,
      },
      {
        name: "Terraform",
        icon: <i class="devicon-terraform-plain colored"></i>,
      },
    ],
  },
];
